import { getOr, set } from 'lodash/fp';

export default (pathFrom, pathTo = pathFrom, defaultValue = null) =>
  (acc, source) => {
    const value = getOr(defaultValue, pathFrom, source);

    return set(pathTo, value, acc);
  };
